import * as Yup from "yup";

export const dataRequestSchema = Yup.object().shape({
  requiredInformation: Yup.string().required(),
  employeer: Yup.string().required(),
});

export const dataRequestDefaultValues = {
  purposeOfRequestingData: "0",
  formOfDataRequested: "1",
};
